<template>

        <md-card>
          <!-- <md-card-header class="md-card-header-icon">
            <div class="card-icon">
              <md-icon>design_services</md-icon>
            </div>
            <h4 class="title">
              Kelengkapan
            </h4>
          </md-card-header> -->
          <md-card-content>
            
            <div class="md-layout">
              <div class="md-layout-item">
                <md-checkbox v-model="pkb.pkb_spion">Spion</md-checkbox>
              </div>
              <div class="md-layout-item">
                <md-checkbox v-model="pkb.pkb_battery_1">Battery 1</md-checkbox>
              </div>
              <div class="md-layout-item">
                <md-checkbox v-model="pkb.pkb_battery_2">Battery 2</md-checkbox>
              </div>
              <div class="md-layout-item">
                <md-checkbox v-model="pkb.pkb_rak_depan">Rak Depan</md-checkbox>
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item">
                <md-checkbox v-model="pkb.pkb_rak_belakang">Rak Belakang</md-checkbox>
              </div>
             
            </div>
           
          
            
          </md-card-content>
        </md-card>  
</template>
<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
  import {extend} from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
extend('no', {
  ...required,
  message: 'No is required'
  });
  extend('tanggal', {
  ...required,
  message: 'tanggal is required'
  });
export default {
  name: "kelengkapan-card",

  props: {
    pkb: null,
  },

  components: {  },

  mixins: [formMixin],

  data() {
    return {};
  },

  methods: {
  
  },
};
</script>

<style></style>
